/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportRecordBuyer
 */
export interface ReportRecordBuyer {
    /**
     * 
     * @type {number}
     * @memberof ReportRecordBuyer
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ReportRecordBuyer
     */
    name: string;
}

/**
 * Check if a given object implements the ReportRecordBuyer interface.
 */
export function instanceOfReportRecordBuyer(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ReportRecordBuyerFromJSON(json: any): ReportRecordBuyer {
    return ReportRecordBuyerFromJSONTyped(json, false);
}

export function ReportRecordBuyerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportRecordBuyer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function ReportRecordBuyerToJSON(value?: ReportRecordBuyer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

